
import Header from 'thesis-and-dissertations/layouts/app/components/Header';
import InputSearch from 'thesis-and-dissertations/layouts/app/components/InputSearch';
import Login from './Login';
import Register from './Register';
import ResetPassword from './ResetPassword';
import { useParams } from 'react-router-dom'

import './style.css'
import { useEffect, useState } from 'react';
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError';

import Api from '../../helpers/api';
const api = new Api();

const Auth = () => {
    const { page } = useParams()
    const [totalThesis, setTotalThesis] = useState(0)

    useEffect(() => {
        fetchTotalThesis()
    }, [])

    const pageLayout = (pageParam) => {
        switch (pageParam) {
            case 'register':
                return <Register />
            case 'reset':
                return <ResetPassword />
            default:
                return <Login />
        }
    }

    const fetchTotalThesis = () => {
        api.getTotalThesis()
            .then(response => {
                const {data} = response
                setTotalThesis(data?.total)
            }).catch((error) => {
                handleApiError(error)
            })
    };

    return (
        <div className='col-md-12 col-xs-12 col-sm-12' style={{ backgroundColor: '#FAF9F5' }}>
            <Header />

            <div style={styles.bgImage} className='p-10 search-box'>
                <div className='p-15 search-box-content'>
                    <div className='text-center'>
                        <p className='display-6 fw-bold mb-5 text-white fw-bold'>Tesis & Disertasi</p>
                        <p className='fs-6 fw-bold mb-15 text-white'>Berisi {totalThesis} Karya Akhir Alumni LPDP</p>
                    </div>

                    <div className='d-flex justify-content-center mb-15'>
                        <InputSearch />
                    </div>
                </div>
            </div>

            <div className='mt-15'>
                {pageLayout(page)}
            </div>
        </div >
    );
};
const styles = {
    bgImage: {
        backgroundColor: '#F95E2F',
        boxShadow: '-5px 50px 50px 20px #F95E2F'
    },
    badge: {
        border: '1px solid #F95E2F'
    },
    searchButton: {
        borderRadius: '0 5px 5px 0',
        border: 'none'
    },
    bgLogin: {
        backgroundImage: 'linear-gradient(180deg, rgba(25, 25, 25, 0.73) 0%, rgba(0, 0, 0, 0.9) 100%)',
        marginTop: '-70px',
        borderRadius: '60px 60px 0 0'
    },
}


export default Auth;